import { useState } from 'react'
export default function useValidation() {
  const [error, setError] = useState({})
  const [error2, setError2] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [errorPAN, setErrorPAN] = useState('')
  const [error3, setError3] = useState({
    firstName: '',
    lastName: '',
    employmentType: '',
    dob: '',
    phone: '',
    email: '',
    password: '',
    reportingTime: '',
    reportingManager: '',
    position: '',
    rank: '',
    region: '',
    zone: '',
    area: '',
    state: '',
    city: '',
    district: '',
    assignStore: '',
    name: '',
    type: '',
    targetTemplateCategory: '',
    targetFor: '',
    channelType: '',
    basedOn: '',
    file: '',
  })

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  function validatePhone(phone) {
    const phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    return phoneno.test(phone)
  }

  function validatePassword(password) {
    let companyPasswordRequirement = JSON.parse(localStorage.getItem('company')).passwordRequirement
    if (!companyPasswordRequirement) return ''
    let { maxCharacter, minCharacter, minLowercase, minUppercase, minNumber, minSpecial } = companyPasswordRequirement
    let lower = 0
    let upper = 0
    let special = 0
    let number = 0
    let passwordLength = password.length
    if (passwordLength < minCharacter) return `Password should be of minimum ${minCharacter} length`
    if (maxCharacter > 0 && passwordLength > maxCharacter) return `Password should be of maximum ${maxCharacter} length`
    for (let i = 0; i < passwordLength; i++) {
      let p = password[i]
      if (p >= 'a' && p <= 'z') lower++
      else if (p >= 'A' && p <= 'Z') upper++
      else if (p >= '0' && p <= '9') number++
      else special++
    }

    if (minLowercase && lower < minLowercase) return `Password must contain atleast ${minLowercase} LowerCase character${minLowercase > 1 ? 's' : ''}`
    if (minUppercase && upper < minUppercase) return `Password must contain atleast ${minUppercase} UpperCase character${minUppercase > 1 ? 's' : ''}`
    if (minNumber && number < minNumber) return `Password must contain atleast ${minNumber} number${minNumber > 1 ? 's' : ''}`
    if (minSpecial && special < minSpecial) return `Password must contain atleast ${minSpecial} special character${minSpecial > 1 ? 's' : ''}`
    return ''
  }

  const handleValidation = (value, field) => {
    let tempError = []
    tempError[`${value}`] = !field ? `This Field is Required` : null
    setError(tempError)
  }

  const handleFormValidation = (e, conditions = []) => {
    let mssg = ''
    let value = e.target.value
    let name = e.target.name
    if (!value) {
      mssg = 'This Field is Required'
    }
    !mssg &&
      conditions.forEach((condition) => {
        if (condition.cond && condition.cond(value)) {
          mssg = condition.message ? condition.message : 'Enter a Valid Value'
        } else if (condition.type) {
          switch (condition.type) {
            case 'EMAIL':
              if (!validateEmail(value)) mssg = condition.message ? condition.message : 'Enter a Valid Email'
              break
            case 'PHONE':
              if (!validatePhone(value)) mssg = condition.message ? condition.message : 'Enter a Valid Phone Number'
              break
            case 'PASSWORD':
              let valPass = validatePassword(value)
              if (valPass) mssg = condition.message ? condition.message : valPass
              break
            default:
              return ''
          }
        }
      })

    setError({ ...error, [name]: mssg })
  }

  const handleValidation2 = (value, name) => {
    setError3({ ...error3, [name]: `${!value ? 'This Field is Required' : ''}` })
    //console.log('ERROR 3 ', error3)
  }
  const handleValidationPAN = (value) => {
    var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
    !regpan.test(value) ? setErrorPAN('Enter Valid PAN') : setErrorPAN('')
  }
  const handleValidationMobile = (value) => {
    // //console.log('Phone Number',value.length)
    if (value === '' || value === ' ') {
      setError2('This Field is Required')
    } else if (value.length === 10) {
      setError2('')
    } else if (value.length !== 10) {
      setError2('Number Should consists 10 Digits')
    }
  }
  const handleValidationEmail = (value) => {
    // //console.log('Phone Number',value.length)
    //  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value === '' || value === ' ') {
      setErrorEmail('This Field is Required')
    }
    //console.log('ERROR EMAIL', errorEmail)
    //  else if (re.test(String(value).toLowerCase())){
    //  setErrorEmail('')
    // }
    //  else{
    //   setErrorEmail('Enter A valid Email')
    // }
  }
  return {
    error,
    error2,
    handleValidation,
    handleValidation2,
    handleValidationMobile,
    error3,
    handleValidationEmail,
    errorEmail,
    handleFormValidation,
  }
}
